import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import ShowPakej from '../components/ShowPakej';
import EditFeature from './EditFeature';
import AddFeature from './AddFeature';

function Pakej() {  
  const [addPakej, setAddPakej] = useState(false);
  const [editPakej, setEditPakej] = useState(null); // New state for editing

  return (
    <div>
      <Helmet>
        <title>Pakej | PanggilanMajlis.com</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {addPakej ? (
        <AddFeature setAddPakej={setAddPakej} />
      ) : editPakej ? (
        <EditFeature featureId={editPakej} setEditPakej={setEditPakej} /> // Pass the item ID to EditItem
      ) : (
        <div className=''>
          <div className='flex items-center justify-between'>
            <div>
              <h1 className="text-3xl font-bold mb-4">Pakej</h1>
              <p>Ubah pakej mengikut kesesuaian</p>
            </div>
            <button onClick={() => setAddPakej(true)} className='text-b1Text bg-button1 hover:bg-button1Hover p-2 md:px-5 rounded-lg'>
              Add Pakej
            </button>
          </div>
          <ShowPakej setEditPakej={setEditPakej} /> {/* Pass setEditItem to ShowItems */}
        </div>
      )}
    </div>
  );
}

export default Pakej;
